module.exports = __webpack_public_path__ + "img/logo.259994e9.png";